/** The `model` options of the Kling definition (`model.name` `kling`), which core's `klingModelMap` reads. */
export const KLING_3_STANDARD_VARIANT = '3.0 Standard';
export const KLING_3_PRO_VARIANT = '3.0 Pro';
